import DiscordIcon from "../../../../apps/web/src/components/logos/DiscordIcon";
import GoogleIcon from "../../../../apps/web/src/components/logos/GoogleIcon";
import TelegramLogo from "../../../../apps/web/src/components/logos/TelegramIcon";

export enum AuthProvider {
  TELEGRAM = "telegram",
  GOOGLE = "google",
  DISCORD = "discord",
  EMAIL = "email",
}

const whiteListedProviders = [AuthProvider.DISCORD];

export const doesProviderNeedPinConfirmation = (provider: AuthProvider) => {
  return !whiteListedProviders.includes(provider);
};
